module.exports = __webpack_public_path__ + "img/portrait-091.d0727181.jpg";